import React from 'react';

import { Stack, Typography } from '@mui/material';
import { useFinanceContext } from 'src/components/plaid/datasource';
import AddAccount from '../../plaid/account/add-account';
import AccountList from '../../plaid/account/accounts-list';
import { SlideIn } from '../SlideIn';
import { FormFooter } from './FormFooter';

export default function ConnectContent({ onNext, onBack }) {
  const { accounts } = useFinanceContext();
  const isValid = accounts?.length > 0;

  return (
    <>
      <Stack spacing={4} alignItems="center" justifyContent="center" textAlign="center">
        <SlideIn direction="left">
          <Typography variant="h2" color="text.secondary">
            🏦
          </Typography>
          <Typography variant="h1">Connect Accounts</Typography>
          <SlideIn direction="left">
            <Typography variant="h3" color="text.secondary" fontWeight="light">
              Get started by linking your financial institution(s).
            </Typography>
          </SlideIn>
          <AccountList />
          <AddAccount />
        </SlideIn>
      </Stack>
      <FormFooter {...{ isValid, onNext, onBack }} />
    </>
  );
}
